import { css } from '@emotion/css'
import { zIndex, fontSize, fontWeight, spacing, fontFamily } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'
import { accessiblyHidden } from '../../utils/styleUtils'

const styles = {
  wrapper: css({
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    zIndex: zIndex.level10,
    paddingTop: 60,
    transition: 'opacity 0.2s',
  }),

  overlay: css({
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level9,
  }),

  container: css({
    position: 'relative',
    zIndex: zIndex.level10,
    height: '100%',
    backgroundColor: colors.white,
    overflowY: 'auto',
    transition: 'transform 0.3s',
  }),

  header: css({
    padding: shorthandHelper([spacing.default, spacing.default]),
    color: colors.white,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    display: 'grid',
    gridColumnGap: '1rem',
    gridTemplateColumns: '1fr auto',

    '& > div': {
      alignSelf: 'start',
      textAlign: 'center',
      width: '100%',
    },

    '& > button': {
      verticalAlign: 'top',
      padding: 0,
      margin: 0,
      border: 'none',
      lineHeight: 1,
      height: 20,
      backgroundColor: 'transparent',
    },
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles

export const wrapperTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        opacity: 0,
      })

    case 'entered':
      return css({
        opacity: 1,
      })

    case 'exiting':
    case 'exited':
    default:
      return css({
        opacity: 0,
      })
  }
}

export const containerTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        transform: 'translateY(100%)',
      })

    case 'entered':
      return css({
        transform: 'translateY(0)',
      })

    case 'exiting':
    case 'exited':
    default:
      return css({
        transform: 'translateY(100%)',
      })
  }
}

export const headerTheme = theme => {
  const themed = getThemeColors(theme)

  if (theme === 'light') {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo,
    })
  }
  return css({
    backgroundColor: themed.base,
  })
}

export const iconColor = theme => {
  if (theme === 'light') return colors.jumbo
  return colors.white
}
